export default "//yastatic.net/s3/distribution/pythia/frontend/_/bfd0066697634f32da20bdefd876c2a0.png";